import {getParent, getRoot, types} from 'mobx-state-tree';
import TreeNode from './TreeNode';
import Country from './Country';


export default types.model('Tree',
    {
        TreeType: types.optional(types.string, "nav"),
        Id: types.optional(types.number, 0),
        NodePath: types.optional(types.string, ""),
        Name: types.maybeNull(types.string),
        PathSegment: types.optional(types.string, ""),
        ActivePath: types.optional(types.array(types.number), []),
        //CurrentPath: types.optional(types.string, ""),
        CurrentSiteId: types.optional(types.number, 0),
        Children:
            types.optional(types.array(TreeNode),
                []), // types.optional(types.array(types.late( () => types.array(TreeNode))), [])
        Visible: types.optional(types.boolean, true),
        MobileViewHeight: types.optional(types.number, 0),
        MobileContentHeight: types.optional(types.number, 0),
        //NavigationRootRegex: types.optional(types.string, "/nav"), // used to handle navigation-state
        Url: types.optional(types.string, ""),
        SearchUrl: types.optional(types.string, ""),
        CheckoutUrl: types.optional(types.string, ""),
        Countries: types.optional(types.array(Country), [])

    }).views(self => ({
        get NavigationRootRegex() {
            return "/" + self.Name;
        },
        get Path() {
            return "";
            let node = self;
            let path = "";
            while (node) {
                //console.debug("path", node);
                path = "/" + node.PathSegment + path;
                node = getParent(node, 2); // Jump array list

                // Handle Tree and TreeNode.
                if (node.$treenode.type.name.substr(0, 4) !== "Tree") {
                    node = null;
                }
            }
            return path;
        },

        ChildrenView(extendWithChildNodes = null) {
            if(extendWithChildNodes == null) 
                return self.Children;
            
            //let childrenView = [...self.Children, ...self.Navigation.marketSettings.MarketNavigationTree.Children];
            //
            // if (self.Navigation.isMobile && !childrenView.find(x=>x.Alias === "icom_MobileMarketNavigation")) {
            //     const marketNavigationNode = this.getMarketNavigation(self);
            //     if(marketNavigationNode) {
            //         childrenView.push(marketNavigationNode);
            //     }
            // }
            return [...self.Children, ...extendWithChildNodes];
            
        },
        getMarketNavigation(parentNode) {
            if(!self.Countries || self.Countries.length === 0) {return;} 
                
            const currentCountry = self.Navigation.CountryCode
                ? self.Countries.find(country => country.CountryCode === self.Navigation.CountryCode)
                : self.Countries.find(country => country.MarketCode === self.Navigation.MarketCode);

            let countries = [];
            self.Countries.map(country => {
                countries.push({
                    Name: country.CountryName,
                    Url: country.ExternalUrl && country.ExternalUrl.length > 0 ? country.ExternalUrl : (country.LanguageUrls && country.LanguageUrls.length > 0 ? country.LanguageUrls[0].FullUrl() : ""),
                    ExternalUrl: country.ExternalUrl,
                    PathSegment: "",
                    Id: country.CountryCode,
                    NodePath: parentNode.NodePath + ",countries," + country.CountryCode,
                    Alias: "icom_MobileMarketNavigationCountry",
                    Children: [],
                    Icon: "/dist/img/flags/square4x3/" + country.CountryCode + ".svg",
                    Visible: true,
                    Highlighted: false,
                    IsDivider: false,
                    LanguageCode: country.LanguageUrls.map(function(elem){
                        return elem.LanguageCode;
                    }).join(","),
                    MarketCode: country.MarketCode,
                    CountryCode: country.CountryCode,
                    MobileContentHeight: 0,
                    CategoryIds: [],
                    d: country.LanguageUrls, // additional data
                    ImageUrl: "/dist/img/flags/square4x3/" + country.CountryCode + ".svg",
                    ChildrenView: []
                });
            });

            let node = {
                Name: currentCountry.CountryName,
                Url: "",
                PathSegment: "",
                Id: "countries",
                NodePath: parentNode.NodePath + ",countries",
                Alias: "icom_MobileMarketNavigation",
                Children: [],
                Icon: null,
                Visible: true,
                Highlighted: false,
                IsDivider: false,
                MobileContentHeight: 0,
                CategoryIds: [],
                d: {}, // additional data
                ImageUrl: "/dist/img/flags/square4x3/" + currentCountry.CountryCode + ".svg",
                ChildrenView: countries,
                setMobileContentHeight(height) {
                    this.MobileContentHeight = height;
                }
            }
            return node;
        },


        get CurrentCountry() {

            return self.Countries.find(country => country.CountryCode === self.Navigation.CountryCode);
        },

        get Navigation() {
            return getRoot(self).navigation;
        },

        get CurrentPath() {
            // 
            //console.debug("Compute CurrentPath", self.Name, self.Navigation.getTreePath(self));
            // The references to the routers are to cheat MobX to update CurrentPath
            let updateTrigger1 = self.Navigation.mainRouter.location;
            let updateTrigger2 = self.Navigation.toolbarRouter.location;
            let updateTrigger3 = self.NavigationRootRegex;
            let path = self.Navigation.getTreePath(self);
            //console.log("Tree -> CurrentPath", path);
            return path;
        }


    })).actions(self => ({
        afterCreate() {
            //self.resetNavigation();
        },
        afterAttach() {
            //console.debug("Tree, afterAttach", self.Name);
        },


        resetNavigation() {
            self.ActivePath = [self.Id];
        },

        navigateToChild(treeNode) {
            console.debug("clicked path: ", treeNode.Path);
            //self.ActivePath.push(treeNode.Id);

            // Todo: connect CurrentPath with Router
            self.Navigation.navigateToSiteUrl(self, null, null, "/" + treeNode.NodePath);
            //self.Navigation.
            //self.CurrentPath = treeNode.Path;
        },

        navigateToTreePath(path) {
            self.Navigation.navigateToSiteUrl(self, null, null, path);
        },

        navigateToChooseCountry() {
            let treeNode = self.ChildrenView().find(function(x) {
                return x.Alias === "icom_MobileMarketNavigation";
            });

            if (!treeNode) {
                return;
            }

            self.navigateToChild(treeNode);
        },

        navigateToId(ancestorId) {
            const index = self.ActivePath.indexOf(ancestorId);
            self.ActivePath = self.ActivePath.slice(0, index + 1);
        },

        navigateToPath(path) {
            self.ActivePath = path;
            //console.debug("action: navigateToPath", self.ActivePath);
        },


        setMobileContentHeight(height) {
            //console.debug(self.Path, height);
            self.MobileContentHeight = height;
        },

        updateViewHeight(height) {

            self.MobileViewHeight = height;
        },

        getNode(id) {
            if (id === self.Id) {
                return self;
            } else {
                for (var node of self.ChildrenView()) {
                    if (node.getNode && typeof node.getNode === 'function') {
                        var result = node.getNode(id);
                        if (result !== null) {
                            return result;
                        }
                    }
                }
            }

            return null;
        }
    }));